// extracted by mini-css-extract-plugin
module.exports = {"content-container":"_dashboard_content-container__2B2J7","dashboard":"_dashboard_dashboard__1iJbc","logout":"_dashboard_logout__2wWAZ"};